import { gql } from '@apollo/client';

export const ASSET2_FRAGMENT = gql`
  fragment asset2Fragment on BaseAsset2 {
    id
    name
    md5
    s3Url
    filename
    createdAt
    updatedAt
    lastSeenAt
    assetTagList {
      id
      description
      displayName
      value
    }
    countryCodes
    language
    subClass
    countryReviews {
      country
      declines {
        reason
        internalComment
        externalComment
      }
      allowedPublishers
      status
    }

    ... on DisplayAsset2 {
      height
      kinko {
        status
        key
      }
      width
    }

    ... on VideoAsset2 {
      videoMetadata {
        duration
        fileSizeBytes
      }
      transcode {
        status
        playbackId
      }
      priority
    }

    ... on TextAsset2 {
      text
    }

    assetSources {
      filename
    }
  }
`;
